import { Scenario } from 'z3k-config';
import { BlocklyError } from 'console/blockly/utils/blockly-error';
import { FixedBlockType } from 'console/blockly/types/block-type';
import { resolverC2B } from 'console/blockly/convertors/config-2-bloclky/index';
import { getUnitTime } from 'console/blockly/utils/time';
function linearRunC2B(config, scenario) {
    return {
        type: FixedBlockType.linear,
        scenario_name: scenario.name,
        statement: resolverC2B(config, scenario.links),
    };
}
function ifRunC2B(config, scenario) {
    const comparator_block = resolverC2B(config, scenario.links);
    return {
        type: FixedBlockType.if_run,
        scenario_name: scenario.name,
        comparator: comparator_block.comparator,
        then: comparator_block.then,
    };
}
function loopRunC2B(config, scenario) {
    const [unit_time, value] = getUnitTime(scenario.loop_time);
    return {
        type: FixedBlockType.loop,
        scenario_name: scenario.name,
        statement: resolverC2B(config, scenario.links),
        unit_time,
        value,
    };
}
function scheduleRunC2B(config, scenario) {
    const min = scenario.timetable.time & 255;
    const hour = scenario.timetable.time >> 8;
    return {
        type: FixedBlockType.schedule_run,
        scenario_name: scenario.name,
        weekday_register: scenario.timetable.weekday_register,
        hour,
        min,
        statement: resolverC2B(config, scenario.links),
    };
}
export function mainC2B(config, scenario) {
    const scenario_type = Scenario.getType(scenario);
    switch (scenario_type) {
        case Scenario.Type.LOOP:
            return loopRunC2B(config, scenario);
        case Scenario.Type.CONDITIONAL:
            return ifRunC2B(config, scenario);
        case Scenario.Type.LINEAR:
            if (scenario.timetable.checked) {
                return scheduleRunC2B(config, scenario);
            }
            return linearRunC2B(config, scenario);
        default:
            throw new BlocklyError('mainC2B', 'Неизвестный тип сценария');
    }
}
